// 设置全局css参数
export const setThemeProperty = (theme: string) => {
	document.documentElement.style.setProperty('--primary-color', theme);
	document.documentElement.style.setProperty('--el-color-primary', theme);
	const foregroundColor = getForegroundColor(theme);
	document.documentElement.style.setProperty('--primary-text-color', foregroundColor);
	document.documentElement.style.setProperty('--primary-gradient-bg-color', getLightColor(theme,0.7));
	document.documentElement.style.setProperty('--primary-getLightColor-bg-color', getLightColor(theme,0.9));
}

/**
 * 根据背景色明亮度返回前景色（黑色或白色）
 * @param {string} bgColor - 背景色，格式为 "#1e6fff" 或 "#e2f0bf"
 * @returns {string} - 前景色，返回 "black" 或 "white"
 */
export const getForegroundColor = (bgColor: string) => {
	// 1. 去除 "#" 符号
	const hex = bgColor.replace("#", "");

	// 2. 将 HEX 转换为 RGB
	const r = parseInt(hex.substring(0, 2), 16) / 255;
	const g = parseInt(hex.substring(2, 4), 16) / 255;
	const b = parseInt(hex.substring(4, 6), 16) / 255;

	// 3. 计算亮度值（Luminance）
	const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

	// 4. 根据亮度值返回前景色
	return luminance > 0.5 ? "#626D83" : "#FFFFFF";
}

/**
 * @description hex颜色转rgb颜色
 * @param {String} str 颜色值字符串
 * @returns {String} 返回处理后的颜色值
 */
export function hexToRgb(str: any) {
	let hexs: any = "";
	const reg = /^#?[0-9A-Fa-f]{6}$/;
	if (!reg.test(str)) return console.error("输入错误的hex");
	str = str.replace("#", "");
	hexs = str.match(/../g);
	for (let i = 0; i < 3; i++) hexs[i] = parseInt(hexs[i], 16);
	return hexs;
}

/**
 * @description rgb颜色转Hex颜色
 * @param {*} r 代表红色
 * @param {*} g 代表绿色
 * @param {*} b 代表蓝色
 * @returns {String} 返回处理后的颜色值
 */
export function rgbToHex(r: any, g: any, b: any) {
	const reg = /^\d{1,3}$/;
	if (!reg.test(r) || !reg.test(g) || !reg.test(b)) return console.error("输入错误的rgb颜色值");
	const hexs = [r.toString(16), g.toString(16), b.toString(16)];
	for (let i = 0; i < 3; i++) if (hexs[i].length == 1) hexs[i] = `0${hexs[i]}`;
	return `#${hexs.join("")}`;
}

/**
 * @description 加深颜色值
 * @param {String} color 颜色值字符串
 * @param {Number} level 加深的程度，限0-1之间
 * @returns {String} 返回处理后的颜色值
 */
export function getDarkColor(color: string, level: number) {
	const reg = /^#?[0-9A-Fa-f]{6}$/;
	if (!reg.test(color)) return console.error("输入错误的hex颜色值");
	const rgb = hexToRgb(color);
	for (let i = 0; i < 3; i++) rgb[i] = Math.round(20.5 * level + rgb[i] * (1 - level));
	return rgbToHex(rgb[0], rgb[1], rgb[2]);
}

/**
 * @description 变浅颜色值
 * @param {String} color 颜色值字符串
 * @param {Number} level 加深的程度，限0-1之间
 * @returns {String} 返回处理后的颜色值
 */
export function getLightColor(color: string, level: number) {
	const reg = /^#?[0-9A-Fa-f]{6}$/;
	if (!reg.test(color)) return console.error("输入错误的hex颜色值");
	const rgb = hexToRgb(color);
	for (let i = 0; i < 3; i++) rgb[i] = Math.round(255 * level + rgb[i] * (1 - level));
	return rgbToHex(rgb[0], rgb[1], rgb[2]);
}
